import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from "react";
import styled, { useTheme } from "styled-components";
import randomColor from "randomcolor";
import { Label, Dropdown, Icon, InputText, Grid } from "~/components-shared";
const Wrapper = styled.div`
  ${_ref => {
  let {
    $s,
    theme
  } = _ref;
  return theme.spacing.resolve(theme, $s);
}};
  ${_ref2 => {
  let {
    $fullWidth
  } = _ref2;
  return $fullWidth && "width: 100%";
}};
  ${_ref3 => {
  let {
    $maxWidth
  } = _ref3;
  return $maxWidth && `max-width: ${$maxWidth}`;
}};
`;
const Field = styled.div`
  background-color: ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.background.dark;
}};
  width: 100%;
  border: none;
  border-radius: ${_ref5 => {
  let {
    theme
  } = _ref5;
  return theme.shape.borderRadius.primary;
}};
  font-weight: ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme.typography.fontWeight.regular;
}};
  display: flex;
  align-items: center;
  transition: box-shadow 200ms ease-in;
  box-shadow: rgb(255 255 255) 0 0 0 0, transparent 0 0 0 1px;
  ${_ref7 => {
  let {
    $outline,
    $hasError,
    theme
  } = _ref7;
  return theme.shadows.outline(theme, $outline, $hasError ? theme.colors.danger.main : theme.colors.primary.main);
}}
`;
const Error = styled.span`
  font-size: 0.8rem;
  display: inline-block;
  margin-left: 0.5rem;
  color: ${_ref8 => {
  let {
    theme
  } = _ref8;
  return theme.colors.danger.main;
}};
`;
const ColorButton = styled.button`
  width: 2.3rem;
  height: 2.3rem;
  background-color: ${_ref9 => {
  let {
    $color
  } = _ref9;
  return $color;
}};
  border: none;
  border-radius: 50%;
  cursor: pointer;
  ${_ref10 => {
  let {
    theme
  } = _ref10;
  return theme.shadows.outline(theme, false);
}}

  &:hover {
    ${_ref11 => {
  let {
    theme
  } = _ref11;
  return theme.shadows.outline(theme, true);
}}
  }
`;
const Color = styled.div`
  width: 2rem;
  height: 2rem;
  background-color: ${_ref12 => {
  let {
    $color,
    theme
  } = _ref12;
  return $color || theme.colors.borders.secondary;
}};
  border-radius: 50%;
  margin-right: 0.6rem;
`;
const StyledDropdownList = styled(Dropdown.List)`
  width: 220px;
`;
const InputColor = _ref13 => {
  let {
    label,
    value = "",
    direction = "bottomRight",
    error,
    onChange = () => false,
    required = false,
    disabled = false,
    maxWidth,
    fullWidth = false,
    s,
    outline,
    children,
    labelProps,
    ...rest
  } = _ref13;
  const theme = useTheme();
  const [generatedColors] = useState(randomColor({
    count: 20,
    luminosity: "light",
    hue: theme.colors.primary.main
  }));
  const customHandler = (toggle, isOpen) => /*#__PURE__*/React.createElement(Field, {
    onClick: toggle,
    $outline: isOpen || outline,
    $hasError: false
  }, /*#__PURE__*/React.createElement(InputText, _extends({
    elemBefore: /*#__PURE__*/React.createElement(Color, {
      $color: value
    }),
    elemAfter: /*#__PURE__*/React.createElement(Icon, {
      src: "chevron",
      scale: 5,
      color: theme.colors.text.secondary,
      rotate: isOpen ? 0 : 180
    }),
    value: value,
    autoComplete: "off",
    outline: false
  }, rest)));
  return /*#__PURE__*/React.createElement(Wrapper, {
    $s: s,
    $maxWidth: maxWidth,
    $fullWidth: fullWidth
  }, !!label && /*#__PURE__*/React.createElement(Label, _extends({
    required: required,
    disabled: disabled,
    s: {
      mb: 2
    }
  }, labelProps), label), /*#__PURE__*/React.createElement(Dropdown, {
    direction: direction,
    customHandler: customHandler
  }, _ref14 => {
    let {
      isOpen,
      onItemClick
    } = _ref14;
    return /*#__PURE__*/React.createElement(StyledDropdownList, {
      isOpen: isOpen
    }, /*#__PURE__*/React.createElement(Grid, {
      cols: 5,
      gap: 3,
      s: {
        p: 3
      }
    }, generatedColors.map(color => /*#__PURE__*/React.createElement(ColorButton, {
      key: color,
      $color: color,
      onClick: () => {
        onItemClick();
        onChange(color);
      }
    }))));
  }), error && /*#__PURE__*/React.createElement(Error, null, error));
};
export default InputColor;